import { AfterViewInit, BootstrapOptions, Component, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2, ViewChild, booleanAttribute } from '@angular/core';
import { DataService } from '../services/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmEventType, ConfirmationService, Message, MessageService } from 'primeng/api';
import { PermissionHandlerService } from '../services/permission-handler.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageuploadService } from '../services/imageupload.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalConstants, ImageTypes } from '../services/global-constants';
import { TranslatorPipe } from '../services/translator.pipe';
import { DatePipe, Location } from '@angular/common';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { ContentViewTypes } from './content-view/content-view.component';
import { cloneDeep } from 'lodash';
import { FileUploadComponent } from '../misc/component/common/file-upload/file-upload.component';
import { breadcrumb, link, stat } from '../admin/layout/header/header.component';
import { DocTypeService } from '../services/doc-type.service';

@Component({
  selector: 'app-training-page',
  templateUrl: './training-page.component.html',
  styleUrl: './training-page.component.scss',
  providers: [MessageService]
})
export class TrainingPageComponent implements OnChanges {

  @Input() isInnerComponent: any = undefined
  @Output() closeTrainingPage: EventEmitter<any> = new EventEmitter()

  reminderModal: boolean = false;
  


  header = this.translate('Training');
  links: link[] = [
    // {
    //   name: 'Add New',
    //   icon: 'pi pi-plus',
    //   link: '',
    //   visible: this.permissionService.hasPermission('DATA', 'c'),
    // },
  ];
  // breadcrumbs: breadcrumb[] = [{ name: this.translate('Data panel'), link: '/admin/dashboard' }];
  stats: stat[] = [
  ];

  //Elements
  @ViewChild("materialUploadElem")
  materialUploadElem?: FileUploadComponent

  //Subjects
  private courseMaterialSubject: Subject<any> = new Subject<any>();
  private sessionReorderSubject: Subject<any> = new Subject<any>();

  //Constants
  additionTabs = AdditionTabs;
  trainingDataTabs = TrainingDataTabs;
  contentType = SessionContentType;
  GlobalConstants = GlobalConstants;

  //Form Groups
  updateCourseForm: FormGroup = this.fb.group({
    title: ['', Validators.required],
    start_date: ['', Validators.required],
    end_date: ['', Validators.required],
    description: ['', Validators.required],
    master_trainer: ['']
  });

  createMaterialForm: FormGroup = this.fb.group({
    title: ['', Validators.required],
    url: [''],
    date: [new Date()],
    sessionType: ['Material', Validators.required],
    video_mode: ['Preview', Validators.required],
    text: ['']
  });

  //Data Variables
  @Input() courseId: string = '';
  courseData: any;
  sessions: any[] = [];
  courseMaterial: any[] = []
  certificate: any[] = []
  trainingType: any;
  sources: any[] = []
  assessments: any[] = []
  surveys: any[] = []
  contents: any[] = [];
  attendances: any[] = [];
  allSessions: any[] = [];
  allowedTabs: TrainingDataAdditionTabs = {
    online_session: false,
    onside_session: false,
    video_session: false,
    add_assessment: false,
    add_survey: false,
    certificate: false
  }
  allowedTabsStrings: string[] = [];
  externalUser: any;
  externalTrainers: any[] = [];
  internalTrainers: any[] = [];
  trainers: any[] = [];
  city: Array<Location | any> = [];
  trainingMaterialImageType = ImageTypes.training_material
  allowedSessionCount: number = 0;
  dateType: string = ''
  companyId: string = '';
  branchId: string = '';
  userId: any;
  materialVideoContentType = ContentViewTypes.Video
  uploadedMaterialSource: string = '';
  activeMaterialIndex: number = 0;
  attendancePercentageFilterValues: { label: string, value: number }[] = [
    { label: "10%", value: 10 },
    { label: "20%", value: 20 },
    { label: "30%", value: 30 },
    { label: "40%", value: 40 },
    { label: "50%", value: 50 },
    { label: "60%", value: 60 },
    { label: "70%", value: 70 },
    { label: "80%", value: 80 },
    { label: "90%", value: 90 },
    { label: "100%", value: 100 },
  ]

  //Toogle Variables
  currentSession: any;
  currentDataTab: TrainingDataTabs = TrainingDataTabs.Session;
  skelition: boolean = true;
  fetchingMangers: boolean = false;
  courseEdit: boolean = false;
  addAssessmentModal: boolean = false;
  addSessionModal: boolean = false;
  addCourseMaterial: boolean = false;
  editSessionModal: boolean = false;
  addSurveyModal: boolean = false;
  addSourcesModal: boolean = false;
  addUserModal: boolean = false;
  showInternal: boolean = true;
  addTrainerModal: boolean = false;
  addTrainnerModal: boolean = false;
  addAttendanceModal: boolean = false;
  dateValidationMessage: any = {};
  allowSessionAdd: boolean = false;
  recreateSessionModal = false;
  certificateTabSelected: boolean = false;
  showImpactSettings: boolean = false;
  allowImpactSettings: boolean = true;
  fromPercentage: number = 0;
  toPercentage: number = 0;

  // markAtte
  internalExternalValue: string = '';
  sessionType: any = 'onsite';
  updateAssessmentData: any;
  updateSurveyData: any;
  updateMaterialData: any;

  //Pop Messages
  messages: Message[] = [];

  //Update modals
  openUpdateTrainingModal = false;

  //Conditional Renderer
  viewOnly: boolean = true;

  //Url Params
  from: any;

  currentURL !: string

  blockOptions: any[] = [
    { name: this.translate('Preview status'), value: 'Preview' },
    { name: this.translate('Block status'), value: 'Block' },
    { name: this.translate('Unblock status'), value: 'Unblock' }
  ];

  isCertAdd: boolean = false
  certType: number = 1;

  showRatingData: boolean = false;
  userRating: any = undefined
  ratingModal: boolean = false
  courseTrainers: any = undefined
  courseAttendees: any[] = [];
  filteredAttendees: any[] = [];
  selectedTrainers: any = undefined
  impactTrainers: any[] = [];
  selectedSurveryIDUsers: string = '';
  selectedSurveryIDTrainers: string = '';
  selectedSurveyImpactID: string = '';

  ratingSettingModal: boolean = false
  fromRating: boolean = false
  ratingType: string = 'User';
  trainingRequest: any;
  showRatingSettings: boolean = false;
  allowRatingTrainers: boolean = false;
  isTrainer: boolean = false;
  isMasterTrainer: boolean = false;

  breadcrumbs: breadcrumb[] = [];


  //Constructor
  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private fb: FormBuilder,
    private location: Location,
    private docService: DocTypeService,
    private messageService: MessageService,

  ) {
    this.courseMaterialSubject
      .pipe(
        debounceTime(5000),
        distinctUntilChanged()
      )
      .subscribe((value: string) => {
        this.updateMaterialOrder()
      });
    this.sessionReorderSubject.pipe(
      debounceTime(5000),
      distinctUntilChanged()
    )
      .subscribe((value: string) => {
        this.updateSessionOrders()
      });

    this.currentURL = this.router.url
  }

  getContentType(source: any) {
    return this.docService.getMaterialContentTypes(source)
  }

  goBack() {

    if (!!this.isInnerComponent) {
      this.closeTrainingPage.emit(true)
    } else {
      this.location.back()
    }
  }

  openAttendanceModal(viewAttendance: boolean) {
    this.currentSession.courseAttendees = this.courseData?.attendees;
    this.currentSession.historyView = { view: viewAttendance, proof: this.currentSession.attendanceProof?.proof_url };
    this.addAttendanceModal = true;
  }

  checkUserEnrollment() {
    let uid = localStorage.getItem('uid')
    return this.courseData.attendees.includes(uid);
  }

  ngOnChanges() {
    this.ngOnInit()
  }





  ngOnInit() {
    if (this.isInnerComponent) {
      this.viewOnly = false
    }

    this.userId = localStorage.getItem('uid');
    this.allowImpactSettings = this.permissionService.hasPermission('IMPACT_SETTINGS', 'a')
    !this.isInnerComponent && this.route.queryParams.subscribe(qParams => {
      let rawType = localStorage.getItem('externalUser')
      if (rawType) {
        let role = JSON.parse(rawType);
        if (role.role == 'trainer') {
          console.log('this is trainer')
          this.viewOnly = true;
          this.isTrainer = true;
          this.checkMasterTrainer();
        }
      }
      if (!qParams['flag']) {
        this.viewOnly = true
      }
      if (qParams['flag']) {
        if (qParams['flag'] == 'VIEW') {
          this.viewOnly = true
        } else if (qParams['flag'] == 'EDIT') {
          this.viewOnly = false;
        }
      } else {
        this.from = qParams['from']
        if (this.from == 'Manager' || this.from == 'SBC') {
          this.viewOnly = false;
        } else if (this.from == 'User') {
          this.viewOnly = true;
        }
      }

      console.log("this.showRatingData Before", this.showRatingData)


      if (qParams['showRatingData']) {
        this.showRatingData = (qParams['showRatingData'] == 'false') ? false : true;

        console.log("this.showRatingData After", this.showRatingData)
      }
      this.checkMasterTrainer()
    })


    this.route.params.subscribe(param => {
      if (param['courseId'] || this.isInnerComponent) {

        if (!!this.isInnerComponent) {
          this.courseId = this.isInnerComponent._id
        }

        else this.courseId = param['courseId'];
        console.log('COURSE ID', this.courseId)
        this.skelition = true;
        Promise.all([
          this.getCourseData(),
          this.getCity(),
        ])
          .then(e => {
            this.getCourseRating(this.courseId)
            this.skelition = false
            if (this.trainingType.name == 'Skill Training') {
              this.getCompanyData();
            }
            else {
              this.getTrainers('Internal');
              this.trainingType.name != 'WEEKLY' && this.trainingType.name != 'Unified session' ? this.getTrainers('External') : '';
            }

            //breadcrums

            this.breadcrumbs = [
              { name: this.courseData?.training_request?.type?.arabic, link: '/training/skill-training/' + this.courseData?.training_request?.type?._id },
              { name: this.courseData?.title, link: this.currentURL }
            ]

            if (this.trainingType?.name == 'New Branch') {
              this.breadcrumbs = [
                { name: this.courseData?.training_request?.type?.arabic, link: '/training/new-branch' },
                { name: this.courseData?.title, link: this.currentURL }
              ]
            }

            if (this.from == 'User') {
              this.breadcrumbs = [
                { name: this.translate('Profile personly'), link: '/user-profile' },
                { name: this.courseData?.title, link: this.currentURL }
              ]
            }

          });
      } else {
        //navigate to home
      }
    })

    this.createMaterialForm.valueChanges.subscribe(e => {
      console.log(e);
      if (e.video_url) {
        this.getVideoUrl("url")
      }
    })

    //make the user to complete attendance
    let uid = localStorage.getItem('uid');
    if (this.viewOnly && this.canCreateCertificate() && !this.courseData.certifiedUsers.includes(uid)) {
      this.certifyUser()
    }
  }

  changeMaterialSessionType(data: any) {
    if (data.index == 1) {
      this.createMaterialForm.get('sessionType')?.setValue('Material_Text')
      this.updateMaterialData.sessionType = 'Material_Text';
    } else {
      this.createMaterialForm.get('sessionType')?.setValue('Material')
      this.updateMaterialData.sessionType = 'Material';
    }
  }

  checkMaterialActiveIndex() {
    if (this.updateMaterialData != null && this.updateMaterialData != undefined && this.updateMaterialData.sessionType == 'Material_Text') {
      return 1;
    }
    return 0;
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  confirmMaterialDelete(material: any) {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteMaterial(material),
    });
  }

  async deleteMaterial(material: any) {
    try {
      material.remove = true;
      material.courseId = this.courseId;
      let res = await this.dataService.postData(`course/material`, material);
      if (!res.error) {
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.ngOnInit()
        return;
      }
    } catch (e) {
      console.log(e)
    }
  }

  confirmSessionDelete(id: any) {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteSession(id),
    });
  }

  async deleteSession(id: any) {
    try {
      let res = await this.dataService.deleteData(`session/${id}/${this.courseId}`);
      if (!res.error) {
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.ngOnInit()
        return;
      }
    } catch (e) {
      console.log(e)
    }
  }

  async createSession(data: any) {
    data.courseId = this.courseId;
    try {
      let res = await this.dataService.postData('session', data)
      if (!res.error) {
        this.sessionCreated()
        return
      }
      console.log(res.msg)
    } catch (e) {
      console.log(e)
    }
  }

  async updateSession(data: any) {
    data.courseId = this.courseId;
    try {
      if (!!this.updateMaterialData) {
        data._id = this.updateMaterialData._id;
      }
      console.log('UPDATE M DATA', data, this.updateMaterialData);
      let res = await this.dataService.postData('session', data, 'PUT')
      if (!res.error) {
        if (!!this.updateMaterialData) {
          this.updateMaterialData = null;
          this.addCourseMaterial = false;
          this.resetMaterialForm()
        }
        this.sessionCreated()
        return
      }
      console.log(res.msg)
    } catch (e) {
      console.log(e)
    }
  }

  sessionCreated() {
    this.showRatingData = false;
    if (this.showRatingData == false) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { showRatingData: false },
        queryParamsHandling: 'merge'
      });
    }
    this.ngOnInit()
    this.addSessionModal = false;
    this.addAssessmentModal = false;
    this.addSurveyModal = false;
    this.addSourcesModal = false;
    this.addSourcesModal = false;
    this.editSessionModal = false;
    this.recreateSessionModal = false;

  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location.name,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  getTrainers = async (flag: string) => {
    try {
      let query: any
      if (flag == 'Internal') {
        query = {
          'externalUser.status': { $ne: true },
          'externalUser.role': 'trainer'
        }
      }
      if (flag == 'External') {
        query = {
          'externalUser.status': true,
          'externalUser.role': 'trainer'
        }
      }
      let res = await this.dataService.postData('user/get', query);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      if (flag == 'Internal') {
        this.internalTrainers = res?.data.map((item: any) => {
          return {
            name: `${item?.name?.first}  ${item?.name?.middle} ${item?.name?.last} ${this.trainingType.name == 'Skill Training' && item?.externalUser?.company?.name ? `( ${item?.externalUser?.company?.name ? item?.externalUser?.company?.name : ''} )` : ''} `,
            user_id: item._id,
            company_id: item?.externalUser?.company?._id,
            email: item?.email

          };
        });
      }
      else if (flag == 'External') {
        this.externalTrainers = res?.data.map((item: any) => {

          return {

            name: `${item?.name?.first}   ${item?.name?.middle}  ${item?.name?.last} ${this.trainingType.name == 'Skill Training' && item?.externalUser?.company?.name ? `( ${item?.externalUser?.company?.name ? item?.externalUser?.company?.name : ''} )` : ''} `,
            user_id: item._id,
            company_id: item?.externalUser?.company?._id,
            email: item?.email

          };
        });
      }
      this.internalExternal(flag);
    } catch (error) {
      console.log(error);
    }
  };

  materialUploadResponse(res: any) {
    if (typeof res == 'string') {
      this.createMaterialForm.controls['url'].setValue(GlobalConstants.staticFilesURL + res);
      // this.getVideoUrl("url")
    }
  }

  getCourseDates() {
    let start = new Date(this.courseData.start_date);
    let end = new Date(this.courseData.end_date);
    start.setHours(0)
    start.setMinutes(0)
    start.setSeconds(0)

    end.setHours(0)
    end.setMinutes(0)
    end.setSeconds(0)

    return [start, end]
  }

  getCompanyData = async () => {
    try {
      this.externalUser = localStorage.getItem('externalUser');

      let id = JSON.parse(this.externalUser).company
      if (!id) return

      let res = await this.dataService.getData('company/coordinator/' + id);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.externalTrainers = res.data[0]?.trainers ? res?.data[0]?.trainers.map((item: any) => {
        return {
          name: `${item?.name?.first}   ${item?.name?.middle} ${this.courseData?.fromSkills && item?.externalUser?.company?.name ? `( ${item?.externalUser?.company?.name ? item?.externalUser?.company?.name : ''} )` : ''} `,
          user_id: item._id,
          company_id: item?.externalUser?.company?._id,
          email: item?.email
        };
      }) : '';

    } catch (error) {
      console.log(error);
    }
    this.internalExternal('External');
  };

  internalExternal(selectedValue: string) {
    this.internalExternalValue = selectedValue;
    if (selectedValue == 'Internal') this.trainers = this.internalTrainers;
    else this.trainers = this.externalTrainers;
  }

  internalExternalSwitch(type: any) {
    this.showInternal = !(type.checked == true)
  }

  disbleDates(values: any) {
    let temp = new Date();
    let today = new Date(temp.getFullYear(), temp.getMonth(), temp.getDate(), 0, 0, 0);
    let SelectedDate = new Date(values.year, values.month, values.day, 0, 0, 0)
    let courseDate = new Date(this.courseData.date)
    if (SelectedDate.getTime() < today.getTime()) {
      return true;
    }
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (today.getDay() + 2) % 7);
    // Set the end of the week to the next Thursday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    if (SelectedDate < today) {
      return
    }
    // const selectedDay = SelectedDate.getDay();
    // if (selectedDay === 5 || selectedDay === 6) { // 5 is Friday, 6 is Saturday
    //   return true;
    // }
    else if (this.trainingType.name == "WEEKLY" && !(SelectedDate >= startOfWeek && SelectedDate <= endOfWeek)) {
      return true;
    }
    else if (this.trainingType.name == "Unified session") {
      let date = new Date(this.courseData.date);
      if (SelectedDate.getFullYear() != date.getFullYear() || SelectedDate.getMonth() != date.getMonth()) {
        return true;
      }
      else {
        return false;
      };
    }
    else return false;
  }


  translate(value: string) {
    const pipe: TranslatorPipe = new TranslatorPipe();
    return pipe.transform(value);
  }

  async getCourseData() {
    if (this.courseId) {
      try {
        const res = await this.dataService.getData(`course/id/${this.courseId}`);
        if (res.error) {
          console.log(res.msg);
          return;
        }
        this.courseData = res.data[0];
        if (this.courseData) {
          //Structurizing course material
          this.courseMaterial = this.courseData.courseMaterial?.map((m: any) => {
            return {
              title: m.title,
              url: m.url,
              sessionType: 'Material',
              order: m.order
            }
          });

          this.courseMaterial.sort((a: any, b: any) => a.order - b.order);

          this.sessions = this.courseData.session.sort((a: any, b: any) => a.order - b.order);
          this.allSessions = cloneDeep(this.sessions);

          //Extracting Content
          if (this.sessions.length > 0) {
            this.checkSurveyAttempts();
            this.checkAssessmentAttempts()
            this.currentSession = this.sessions.find(e => e.sessionType == 'Preview')
            this.surveys = this.sessions.filter(e => e.sessionType == 'Survey')
            this.assessments = this.sessions.filter(e => e.sessionType == 'Assessment')
            // this.sessions = this.sessions.filter(e => e.sessionType !== 'Survey' && e.sessionType !== 'Assessment')
            // this.attendances = this.sessions.filter(f => ((new Date(f.date)).getTime() <= (new Date()).getTime()) && (f.sessionType == 'Online' || f.sessionType == 'Onsite'))
          } else {
            this.currentSession = null;
          }
          this.trainingType = this.courseData.training_request.type;
          this.companyId = this.courseData.training_request.creator
          this.trainingRequest = this.courseData.training_request;
          if ((!!this.trainingRequest.master_trainer && this.trainingRequest.master_trainer == this.userId) || (!!this.from && this.from == 'SBC')) {
            this.showRatingSettings = true;
          }
          if (!!this.trainingRequest?.ratingSettings?.Trainer && Array.isArray(this.trainingRequest?.ratingSettings?.Trainer)) {
            if (this.trainingRequest?.ratingSettings?.Trainer.includes(this.userId)) {
              this.allowRatingTrainers = true;
            }
          }
          this.checkMasterTrainer()
          this.branchId = this.courseData.training_request.ou;
          this.allowedSessionCount == 1 ? this.dateType = "single" : this.dateType = "range";
          this.allowedTabs = this.trainingType.permissions

          console.log("this.trainingType.permissions", this.trainingType.permissions)

          this.allowedSessionCount = this.trainingType.number_of_sessions;
          this.updateAddSessionValidation()

          if (this.allowedTabs.add_assessment) {
            this.allowedTabsStrings.push("Assessment")
          }
          if (this.allowedTabs.add_survey) {
            this.allowedTabsStrings.push("Survey")
          }
          if (this.allowedTabs.online_session) {
            this.allowedTabsStrings.push("Online")
          }
          if (this.allowedTabs.onside_session) {
            this.allowedTabsStrings.push("Onsite")
          }
          if (this.allowedTabs.video_session) {
            this.allowedTabsStrings.push("Video")
          }
          if (this.allowedTabs.certificate) {
            this.allowedTabsStrings.push("Certificate")
          }

          if (this.courseData?.training_request?.ratingSettings) {
            this.selectedTrainers = this.courseData?.training_request?.ratingSettings?.Trainer;
            this.selectedSurveryIDUsers = this.courseData?.training_request?.ratingSettings?.surveryIdUsers;
            this.selectedSurveryIDTrainers = this.courseData?.training_request?.ratingSettings?.surveryIdTrainers;
          }
        }
      } catch (e: any) {
        console.log(e)
      }
    }
  }

  checkMasterTrainer() {
    if (!!this.trainingRequest) {
      if (!!this.trainingRequest.master_trainer && this.trainingRequest.master_trainer == this.userId) {
        this.allowRatingTrainers = true;
        this.isTrainer = false;
        this.isMasterTrainer = true;
        this.viewOnly = false;
      }
    }
  }

  checkTrainerEditPermission(session: any) {
    if (session?.sessionType == 'Online' || session?.sessionType == 'Onsite') {
      let createdBy = session?.trainer?.user_id;
      if (!!createdBy && createdBy == this.userId) {
        return true;
      }
    }
    return !this.viewOnly;
  }

  async checkSurveyAttempts() {
    try {
      let email = localStorage.getItem('email');

      let ids = this.sessions.filter(e => e.sessionType == 'Survey').map(e => e.surveyId);
      let res = await this.dataService.postData(`survey-attempt/session/check/${email}`, { ids })
      if (!res.error) {
        let data: any[] = res.data;
        this.sessions = this.sessions.map(session => {
          if (session.sessionType == 'Survey') {
            session.attempted = data.find(d => d._id == session.surveyId).attempted
          }
          return session
        });
      }
    } catch (e) {
      console.log(e)
    }
  }

  async checkAssessmentAttempts() {
    try {
      let email = localStorage.getItem('email');
      let ids = this.sessions.filter(e => e.sessionType == 'Assessment').map(e => e.assessmentId);
      let res = await this.dataService.postData(`assessment/attempt/check/${email}`, { ids })
      if (!res.error) {
        let data: any[] = res.data;
        this.sessions = this.sessions.map(session => {
          if (session.sessionType == 'Assessment') {
            let response = data.find(d => d.assessmentId == session.assessmentId)
            if (response) {
              session.result = response
            }
          }
          return session
        });
      }
    } catch (e) {
      console.log(e)
    }
  }

  updateAddSessionValidation() {
    let permissionSessions = this.allSessions.filter(e => e.sessionType != 'Survey' && e.sessionType != 'Assessment')
    if (permissionSessions.length >= this.allowedSessionCount) {
      this.allowSessionAdd = false
    } else {
      this.allowSessionAdd = true;
    }
  }

  dateValidate(SelectedDate: any, key: string) {
    let today = new Date();

    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (today.getDay() + 2) % 7);


    // Set the end of the week to the next Thursday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    if (SelectedDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
      this.dateValidationMessage[key] = "The Date Has Passed";
      this.updateCourseForm.controls[key].setValue(null);
      return
    }

    const selectedDay = SelectedDate.getDay();

    if (selectedDay === 5 || selectedDay === 6) { // 5 is Friday, 6 is Saturday
      this.updateCourseForm.controls[key].setValue(null);
      this.dateValidationMessage[key] = "Please select a date other than Friday or Saturday";
      return;
    }


    else if (this.trainingType.name == "WEEKLY" && !(SelectedDate >= startOfWeek && SelectedDate <= endOfWeek)) {
      this.updateCourseForm.controls[key].setValue(null);
      this.dateValidationMessage[key] = "invalid Date select in current week";
    }

    else if (this.trainingType.name == "Unified session") {
      let date = new Date(this.courseData.date);
      if (SelectedDate.getFullYear() != date.getFullYear() || SelectedDate.getMonth() != date.getMonth()) {
        this.dateValidationMessage[key] = "invalid Date select in current Month : " + date.getMonth();
        this.updateCourseForm.controls[key].setValue(null);
      } else {
        this.dateValidationMessage[key] = "";
      }
    }
    else {
      this.dateValidationMessage[key] = "";
    }
  }

  getVideoUrl(control: string) {
    let url = this.createMaterialForm.get(control)?.value
    if (url) {
      if (this.isYouTubeUrl(url)) {
        const videoIdMatch = url.match(/[?&]v=([^&]+)/);
        this.materialVideoContentType = ContentViewTypes.YTVideo;
        this.uploadedMaterialSource = videoIdMatch ? videoIdMatch[1] : null;
      } else {
        this.materialVideoContentType = ContentViewTypes.Video;
        this.uploadedMaterialSource = url;
      }
    } else {
      this.uploadedMaterialSource = '';
    }
  }

  isYouTubeUrl(url: string): boolean {
    const youtubeRegex = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
    return youtubeRegex.test(url);
  }

  async addMaterial() {
    try {
      let payload = { ...this.createMaterialForm.getRawValue(), courseId: this.courseId }
      if (!!payload.text) {
        payload.sessionType = "Material_Text"
      } else {
        payload.sessionType = "Material"
      }
      // payload.order = this.courseMaterial.length;
      // let res = await this.dataService.postData('course/material', payload)
      this.createSession(payload).then(() => {
        this.materialUploadElem!.uploadInput!.nativeElement.value = ""
        // this.materialUploadElem!.nativeElement.value = ""
        this.addCourseMaterial = false;
        this.resetMaterialForm();
      })
      // if (!res.error) {
      //   this.messages = [
      //     { severity: 'success', summary: this.translate('success') },
      //   ]

      //   this.ngOnInit()
      // }
    } catch (e) {
      console.log(e)
    }
  }

  resetMaterialForm() {
    this.createMaterialForm.get('url')?.reset()
    this.createMaterialForm.get('title')?.reset()
    this.createMaterialForm.get('text')?.reset()
  }

  async updateMaterialOrder() {
    try {
      let res = await this.dataService.postData(`course/material/${this.courseId}`, this.courseMaterial, 'PUT')
      if (!res.error) {
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ]
        this.ngOnInit()
      }
    } catch (e) {
      console.log(e)
    }
  }

  async updateSessionOrders() {
    try {
      let payload = this.sessions.map(e => {
        return { _id: e._id, order: e.order }
      })
      let res = await this.dataService.postData('session/reorder', payload, 'PUT')
      if (!res.error) {
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ]
        // this.ngOnInit()
      }
    } catch (e) {
      console.log(e)
    }
  }

  changeMaterialOrder(material: any, index: number, increment: boolean) {
    if (increment) {
      console.log(this.courseMaterial.length, index, index + 1)
      if (index < this.courseMaterial.length - 1) {
        let oldOrder = material.order;
        material.order = this.courseMaterial[index + 1].order;
        this.courseMaterial[index + 1].order = oldOrder
      }
    } else {
      if (index > 0) {
        let oldOrder = material.order;
        material.order = this.courseMaterial[index - 1].order;
        this.courseMaterial[index - 1].order = oldOrder
      }
    }
    this.courseMaterial.sort((a: any, b: any) => a.order - b.order);
    this.courseMaterial = [...this.courseMaterial]
    this.courseMaterialSubject.next(this.courseMaterial)
  }

  changeSessionOrder(session: any, index: number, increment: boolean) {
    if (increment) {
      if (index < this.sessions.length - 1) {
        let oldOrder = session.order;
        session.order = this.sessions[index + 1].order;
        this.sessions[index + 1].order = oldOrder
      }
    } else {
      if (index > 0) {
        let oldOrder = session.order;
        session.order = this.sessions[index - 1].order;
        this.sessions[index - 1].order = oldOrder
      }
    }
    this.sessions.sort((a: any, b: any) => a.order - b.order);
    this.sessions = [...this.sessions]
    this.sessionReorderSubject.next(this.sessions)
  }

  changeOrder(session: any, index: number, increment: boolean) {
    if (this.currentDataTab == this.trainingDataTabs.CourseMaterial) {
      this.changeMaterialOrder(session, index, increment);
    } else {
      this.changeSessionOrder(session, index, increment)
    }
  }

  getViewContent() {
    switch (this.currentDataTab) {
      case TrainingDataTabs.Assessment:
        return this.assessments;
      case TrainingDataTabs.Survey:
        return this.surveys;
      case TrainingDataTabs.Session:
        return this.sessions;
      case TrainingDataTabs.Source:
        return this.sources;
      case TrainingDataTabs.Contents:
        return this.contents;
      case TrainingDataTabs.Attendance:
        return this.attendances;
      case TrainingDataTabs.CourseMaterial:
        return this.courseMaterial;
      case TrainingDataTabs.Certificate:
        return this.certificate;
    }
  }

  isHistory: boolean = false

  //edit session
  editSession() {
    let type = this.currentSession.sessionType;
    if (type == 'Onsite' || type == 'Online' || type == 'Video' || type == 'Certificate') {
      this.editSessionModal = true
      this.currentDataTab
      if (this.currentDataTab == 5 && (type == 'Onsite' || type == 'Online')) {
        this.isHistory = true
      } else this.isHistory = false

      this.isCertAdd = (type == 'Certificate') ? true : false;

    } else if (type == 'Assessment') {
      this.updateAssessmentData = this.currentSession;
      this.addAssessmentModal = true;
    } else if (type == 'Survey') {
      this.updateSurveyData = this.currentSession;
      this.addSurveyModal = true;
    } else if (type == 'Material_Text' || type == 'Material') {
      type == 'Material_Text' ? this.activeMaterialIndex = 1 : null;
      this.updateMaterialData = this.currentSession;
      this.createMaterialForm = this.fb.group({
        title: [this.currentSession.title, Validators.required],
        url: [this.currentSession.url],
        date: [this.currentSession.date],
        sessionType: [this.currentSession.sessionType, Validators.required],
        video_mode: [this.currentSession.video_mode, Validators.required],
        text: [this.currentSession.text]
      });
      this.addCourseMaterial = true;
    }
  }

  mainAssessmentUpdated() {
    this.addAssessmentModal = false;
    this.ngOnInit();
  }

  mainSurveyUpdated() {
    this.addSurveyModal = false;
    this.ngOnInit()
  }

  updateAssessment(event: any) {
    //TODO:Implement this
    console.log('Assessment Data: ', event);
  }

  handleAddTrainer(event: any) {
    //TODO:Implement this
    console.log('Training Data: ', event);
  }

  updatedAttendees(event: any) {
    this.ngOnInit()
    this.addAttendanceModal = false;
  }

  checkAdditionPermission(title: AdditionTabs) {
    if (title == AdditionTabs.Session) {
      return (this.allowedTabs.video_session || this.allowedTabs.onside_session || this.allowedTabs.online_session || this.allowedTabs.certificate);
    } else if (title == AdditionTabs.Survey) {
      return this.allowedTabs.add_survey
    } else if (title == AdditionTabs.Assessment) {
      return this.allowedTabs.add_assessment
    } else if (title == AdditionTabs.Add_User) {
      return this.trainingType.name != 'Skill Training'
    }
    return false;
  }

  changeCurrentDataTab(trainingDataTab: TrainingDataTabs) {
    this.currentDataTab = trainingDataTab;
    switch (this.currentDataTab) {
      case TrainingDataTabs.Session:
        this.currentSession = this.sessions[0]
        break;
      case TrainingDataTabs.Assessment:
        this.currentSession = this.assessments[0]
        break;
      case TrainingDataTabs.Attendance:
        this.currentSession = this.attendances[0]
        break;
      case TrainingDataTabs.Contents:
        this.currentSession = this.contents[0]
        break;
      case TrainingDataTabs.CourseMaterial:
        this.currentSession = this.courseMaterial[0]
        break;
      case TrainingDataTabs.Source:
        this.currentSession = this.sources[0]
        break;
      case TrainingDataTabs.Survey:
        this.currentSession = this.surveys[0]
        break;
      default:
        this.currentSession = this.sessions[0]
        break;
    }
  }

  async getUserManagers(user: any) {
    if (!!user.managers) {
      return;
    }
    this.fetchingMangers = true;
    try {
      let res = await this.dataService.postData('user/user-managers', { userIds: [user._id] })
      this.fetchingMangers = false;
      if (res.error) {
        user.managers = []
        return;
      }
      user.managers = res.data[0]?.managers.map((e: any) => {
        e.name = e?.name?.first + ' ' + e?.name?.middle + ' ' + e?.name?.last;
        return e;
      })
      user.assignedManager = user.managers[0]?._id;
    } catch (e) {
      this.fetchingMangers = false;
      console.log(e);
    }
  }


  async updateImpactSettings() {
    try {
      let data: any = {
        surveyId: this.selectedSurveyImpactID,
        trainers: [this.impactTrainers],
        users: this.courseAttendees.filter(e => !!e.selected).map(e => {
          return { userId: e._id, assignedManager: e.assignedManager }
        })
      }

      let res = await this.dataService.postData('training-req/', { _id: this.courseData.request_id, impactSettings: data }, 'PUT')
      if (res.error) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Impact Not Created') });
        return
      }

      this.showImpactSettings = false
      this.messageService.add({ severity: 'success', summary: this.translate('Success'), detail: this.translate('Impact Created') });


    } catch (error) {

    }

  }

  changeSession(session: any) {
    this.showImpactSettings = false;
    if (session == 'Certificate') {
      if (session.sessionType != undefined) {
        this.isCertAdd = true;
        this.certType = 1;
        this.currentSession = session;
      }
      else {
        this.isCertAdd = false;
        this.certType = 3;
        this.currentSession = null;
      }
      this.hideRating()
      this.certificateTabSelected = true;
      return;
    }
    if ((session?.sessionType == 'Certificate') && this.canCreateAttendanceCertificate(session)) {
      if (session.sessionType != undefined) {
        this.isCertAdd = true;
        this.certType = 1;
        this.currentSession = session;
      }
      else {
        this.isCertAdd = false;
        this.certType = 3;
        this.currentSession = null;
      }
      this.hideRating()
      this.certificateTabSelected = true;
      return;
    }

    if ((session != 'Certificate' || session?.sessionType != 'Certificate') && this.canPlaySession(session)) {
      this.certificateTabSelected = false;
      this.isCertAdd = false;
      this.currentSession = session;
    }
    this.hideRating()
  }

  hideRating() {

    this.showRatingData = false;
    if (this.showRatingData == false) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { showRatingData: false },
        queryParamsHandling: 'merge'
      });
    }
  }

  async certifyUser() {
    try {
      let uid = localStorage.getItem('uid');
      let data: any = {
        certifiedUsers: [...this.courseData.certifiedUsers, uid],
        _id: this.courseData._id
      }
      let res = await this.dataService.postData('course', data, 'PUT')
      if (!res.error) {
        this.openUpdateTrainingModal = false;
        this.ngOnInit()
      }
    } catch (e) {
      console.log(e)
    }
  }

  canCreateAttendanceCertificate(certificate: any) {
    if (!this.viewOnly) {
      return true;
    }
    let uid = localStorage.getItem('uid');
    let certId = certificate._id;
    let certificateSessionIndex = this.sessions.findIndex(s => s._id == certId);
    if (certificateSessionIndex == -1) {
      return false;
    }
    for (let i = certificateSessionIndex - 1; i >= 0; i--) {
      let current = this.sessions[i];
      if (current.sessionType == 'Certificate') {
        return true;
      } else {
        if (current.video_mode == 'Block') {
          if (current.sessionType == 'Survey' && !current.attempted) {
            return false
          } else if (current.sessionType == 'Assessment' && !(current?.result?.attempts == false || current?.result?.status == 'Pass')) {
            return false
          } else if (current.sessionType == 'Video' || current.sessionType == 'Material') {
            return current.seenby?.includes(uid)
          }
        } else {
          if (current.sessionType == 'Online' || current.sessionType == 'Onsite') {
            if (!current.attendees || !current.attendees?.includes(uid)) {
              return false;
            }
          }
        }
      }
    }
    console.log('PASSED ALL')
    return true;
  }

  isCourseStart() {
    let today = new Date();

    today.setHours(0)
    today.setMinutes(0)
    today.setMilliseconds(0)

    let courseStart = new Date(this.courseData.start_date);

    return (courseStart.getTime() < today.getTime())
  }

  canCreateCertificate() {
    if (!!this.courseData) {
      if (!this.viewOnly) {
        return true;
      }

      let uid = localStorage.getItem('uid');
      let onlineOnsiteSessionCheck, courseEndCheck, surveyCheck, assessmentCheck, blockedVideoCheck, courseStartCheck;

      let today = new Date();

      today.setHours(0)
      today.setMinutes(0)
      today.setMilliseconds(0)

      let courseStart = new Date(this.courseData.start_date);

      courseStartCheck = (courseStart.getTime() < today.getTime())

      //Onsite & Online sessions attendance check
      let onlineOnsiteSessions = this.sessions.filter(v => v.sessionType == 'Online' || v.sessionType == 'Onsite');

      //Course End Date Check
      if (onlineOnsiteSessions.length > 0) {

        onlineOnsiteSessionCheck = onlineOnsiteSessions.some(ov => !((ov.attendees as Array<any>)?.includes(uid)))
        console.log('ONLINE, ONSITE COMPLETE CHECK', onlineOnsiteSessionCheck)

        // let courseEnd = new Date(this.courseData.end_date);

        // courseEndCheck = (courseEnd.getTime() < today.getTime())
        // console.log('COURSE END COMPLETE CHECK', courseEndCheck, courseEnd, today)
      } else {
        onlineOnsiteSessionCheck = false;
        courseEndCheck = false;
      }
      //Survey & Assessments Check
      if (this.surveys.length > 0) {
        surveyCheck = this.surveys.some(s => !s.attempted)
        console.log('SURVEY COMPLETE CHECK', surveyCheck)
      } else {
        surveyCheck = false;
      }

      if (this.assessments.length > 0) {
        assessmentCheck = this.assessments.some(s => {
          console.log('CONDITINO TEST', s?.result?.totalAttempts == 0, s?.result?.totalAttempts)
          return s?.result?.totalAttempts == 0;
        })

        console.log('ASSESSMENT COMPLETE CHECK', assessmentCheck, this.assessments)
      } else {
        assessmentCheck = false;
      }

      //Blocked videos check
      let blockedVideos = this.sessions.filter(v => v.sessionType == 'Video' && v.video_mode == 'Block')
      if (blockedVideos.length > 0) {
        blockedVideoCheck = blockedVideos.some(bv => !((bv.seenby as Array<any>).includes(uid)));
        console.log('BLOCKED VIDEO COMPLETE CHECK', blockedVideoCheck)
      } else {
        blockedVideoCheck = false;
      }
      console.log('TTTTT', onlineOnsiteSessionCheck, surveyCheck, assessmentCheck, blockedVideoCheck)

      return (!onlineOnsiteSessionCheck && !surveyCheck && !assessmentCheck && !blockedVideoCheck);
    }
    return false;
  }

  toDateObj(date: string) {
    return new Date(date);
  }

  isOnlineOnsiteSession(session: any) {
    return (session.sessionType == 'Online' || session.sessionType == 'Onsite');
  }

  canMarkAttendance(session: any) {
    if (this.viewOnly) {
      let first = (session.sessionType == 'Online' || session.sessionType == 'Onsite');
      if (this.isTrainer) {
        return first && (session?.trainer?.user_id == this.userId)
      } else if (this.isMasterTrainer) {
        return true;
      } else return false
    }
    return true;
  }

  getFormattedTime(date: any) {
    try {
      return (new DatePipe("en-us")).transform(date)
    } catch (e) {
      return date;
    }
  }

  sessionUpdated(seenBy: any[]) {
    this.currentSession.seenBy = seenBy;
    this.sessions = [...this.sessions];
  }

  canPlaySession(session: any): boolean {
    if (!this.viewOnly) {
      return true;
    }

    if (this.isTrainer) {
      return this.canMarkAttendance(session);
    }

    if (session.sessionType == 'Certificate') {
      return this.canCreateAttendanceCertificate(session);
    }

    let uid = localStorage.getItem('uid');

    if (session.sessionType == 'Online' || session.sessionType == 'Onsite') {
      return true;
    }

    if (session.video_mode == 'Preview') {
      return true
    }

    let sessionDate = new Date(session.start_time);
    let today = new Date();


    sessionDate.setHours(0)
    sessionDate.setMinutes(0)
    sessionDate.setMilliseconds(0)

    today.setHours(0)
    today.setMinutes(0)
    today.setMilliseconds(0)

    let courseEnd = new Date(this.courseData.end_date);
    let courseStart = new Date(this.courseData.start_date)

    courseEnd.setDate(courseEnd.getDate() + 1);
    courseStart.setDate(courseStart.getDate() - 1);

    if (courseEnd.getTime() < today.getTime()) {
      return false;
    }
    if (courseStart.getTime() > today.getTime()) {
      return false;
    }
    if (!!session.start_date) {
      if (session.video_mode == 'Unblock') {
        return (sessionDate.getTime() < today.getTime() && this.courseData.attendees?.includes(uid))
      }
      if (sessionDate.getTime() > today.getTime() || !this.courseData.attendees?.includes(uid)) {
        return false;
      }
    } else {
      if (session.video_mode == 'Unblock') {
        return (this.courseData.attendees?.includes(uid))
      }
      if (!this.courseData.attendees?.includes(uid)) {
        return false;
      }
    }

    let blockedSessions: any[] = this.sessions.filter(e => e.video_mode == 'Block' || e.sessionType == 'Online' || e.sessionType == 'Onsite')

    //If video is first in list
    if (blockedSessions[0]?._id == session._id) {
      return true
    }

    for (let i = 0; i < blockedSessions.length; i++) {
      if (session._id == blockedSessions[i]._id) {
        let previous = blockedSessions[i - 1]
        if (previous.sessionType == 'Survey') {
          return previous.attempted
        } else if (previous.sessionType == 'Assessment') {
          return (previous?.result?.attempts == false || previous?.result?.status == 'Pass')
        } else if (previous.sessionType == 'Online' || previous.sessionType == 'Onsite') {
          return !!previous.attendees && previous.attendees?.includes(uid)
        } else {
          return previous.seenby?.includes(uid)
        }
      }
    }

    return false;
  }

  handleUpdatedUserData(event: any) {
    this.getTrainers("Internal");
    this.getTrainers("External");
  }

  openRecreateModal(session: any) {
    session
    this.currentSession = session
    this.recreateSessionModal = true

  }

  onSessionDeleteClick(session: any) {
    if (this.currentDataTab == this.trainingDataTabs.CourseMaterial) {
      this.confirmMaterialDelete(session)
    } else {
      this.confirmSessionDelete(session._id)
    }
  }

  async updateCourse() {
    // if (!this.courseData.image) {
    //   return;
    // }
    try {
      let payload = this.updateCourseForm.getRawValue()
      //update master trainer
      if (payload.master_trainer && payload.master_trainer != null) {
        let data: any = {
          '_id': this.courseData.request_id,
          master_trainer: payload.master_trainer.user_id
        }
        let res = await this.dataService.postData('training-req', data, 'PUT')
      }
      //removing master trainer for updating course object
      delete payload.master_trainer

      payload.image = this.courseData.image
      payload._id = this.courseData._id
      delete payload.timeline
      let res = await this.dataService.postData('course', payload, 'PUT')
      if (!res.error) {
        this.openUpdateTrainingModal = false;
        this.ngOnInit()
      }
    } catch (e) {
      console.log(e)
    }
  }


  openTrainingUpdateModal() {
    let trainer = this.internalTrainers.find((e: any) => e.user_id == this.courseData?.training_request?.master_trainer)
    if (!trainer) {
      trainer = this.externalTrainers.find((e: any) => e.user_id == this.courseData?.training_request?.master_trainer)
    }
    this.updateCourseForm = this.fb.group({
      title: [this.courseData.title, Validators.required],
      start_date: [this.toDateObj(this.courseData.start_date), Validators.required],
      end_date: [this.toDateObj(this.courseData.end_date), Validators.required],
      description: [this.courseData.description, Validators.required],
      master_trainer: [trainer],
      timeline: [[this.toDateObj(this.courseData.start_date), this.toDateObj(this.courseData.end_date)]]
    });
    this.openUpdateTrainingModal = true;
  }

  print() {
    console.log(this.updateCourseForm?.value, this.updateCourseForm?.valid)
  }

  onTabChange(event: any) {
    this.ratingType = (event.index == 0) ? 'User' : 'Trainer'
  }

  openRateingModal() {
    this.certificateTabSelected = false
    this.ratingModal = true
    this.getCourseRating(this.courseId)
  }

  openRatingSettingModal() {
    this.certificateTabSelected = false;
    this.ratingSettingModal = true;
    this.fromRating = true;
    this.getCourseRating(this.courseId)
  }

  openImpactSettingModal() {
    this.certificateTabSelected = false;
    this.showImpactSettings = true;
    this.fromRating = true;
  }

  filterByAttendancePercentage() {
    if (!!this.fromPercentage && this.fromPercentage > 0 && !!this.toPercentage && this.toPercentage > 0) {
      console.log('FROM 1',this.fromPercentage,this.toPercentage,this.courseAttendees)
      this.filteredAttendees = this.courseAttendees.filter(e => e.attendancePercentage >= this.fromPercentage && e.attendancePercentage <= this.toPercentage);
    } else if (this.fromPercentage && this.fromPercentage > 0 && (!this.toPercentage || this.toPercentage == 0)) {
      console.log('FROM 2',this.fromPercentage,this.courseAttendees)
      this.filteredAttendees = this.courseAttendees.filter(e => e.attendancePercentage >= this.fromPercentage);
    } else if (this.toPercentage && this.toPercentage > 0 && (!this.fromPercentage || this.fromPercentage == 0)) {
      console.log('FROM 3',this.toPercentage,this.courseAttendees)
      this.filteredAttendees = this.courseAttendees.filter(e => e.attendancePercentage <= this.toPercentage);
    }
  }

  resetFilter() {
    this.filteredAttendees = this.courseAttendees;
    this.fromPercentage = 0;
    this.toPercentage = 0;
  }

  async getCourseRating(id: any) {
    this.fetchingMangers = true;
    let res = await this.dataService.getData('course/trainer-rating/' + id)
    this.fetchingMangers = false;
    if (res.error) {
      return
    }
    this.courseTrainers = res.data.trainers;
    this.courseAttendees = res.data.users;
    this.filteredAttendees = this.courseAttendees;
    this.courseAttendees.forEach(attendee => this.setAttendancePercentage(attendee));
  }

  setAttendancePercentage(user: any) {
    let onlineOnsiteSessions = this.sessions.filter(v => v.sessionType == 'Online' || v.sessionType == 'Onsite');
    let allSessions = 0;
    let present = 0;


    allSessions += onlineOnsiteSessions.length;

    //Online Onsite Session attendance
    if (onlineOnsiteSessions.length > 0) {
      onlineOnsiteSessions.forEach(ov => {
        if ((ov.attendees as Array<any>)?.includes(user._id)) {
          present += 1;
        }
      })
    }

    user.attendancePercentage = (present / allSessions) * 100
  }

  userLabel(user: any): string {
    const { first, middle, last } = user.name;
    return `${first} ${middle} ${last}`;
  }

  getName(name: any) {
    return Object.values(name).join(' ');
  }

  openRatingData() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { showRatingData: true },
      queryParamsHandling: 'merge'
    });
    this.certificateTabSelected = false;
    this.isCertAdd = false;
    this.currentSession = null;
    this.showRatingData = true
  }

  showTrainerImpact = false


  canAttemptImpact() {
    if (!(!!this.courseData.training_request.impactSettings)) return false
    let trainers = !!this.courseData.training_request.impactSettings.trainers ? this.courseData.training_request.impactSettings.trainers : null
    if( typeof trainers === 'object' && !Array.isArray(trainers) ) {
      let isA = Array.isArray(trainers);
      let trainersArray = [trainers];
      let result= trainersArray.includes(this.userId)
      return result
    } else {
      let result = trainers.includes(this.userId)
      return result;
    }
  }

  openTrainerImpact() {

    this.certificateTabSelected = false;
    this.isCertAdd = false;
    this.currentSession = null;
    this.showRatingData = false;
    this.showTrainerImpact = true;
  }

  async UpdateRatingSettings() {
    if (this.ratingType == 'User') {
      if (!this.selectedSurveryIDUsers) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: '' });
        return
      }
    }
    else {
      if (!this.selectedSurveryIDTrainers || !this.selectedTrainers) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: '' });
        return
      }
    }
    try {
      let data: any = {
        '_id': this.courseData.request_id,
        'ratingSettings': {
          'surveryIdUsers': this.selectedSurveryIDUsers,
          'surveryIdTrainers': this.selectedSurveryIDTrainers,
          'Trainer': this.selectedTrainers
        }
      }
      let res = await this.dataService.postData('training-req', data, 'PUT')
      if (!res.error) {
        this.messageService.add({ severity: 'success', summary: this.translate('success'), detail: '' });
        this.ratingSettingModal = false;
      }
      console.log(res.msg)
    } catch (e) {
      console.log(e)
    }
  }

  setSelectedSurvey(data: any) {
    if (data.ratingType == 'User') {
      this.selectedSurveryIDUsers = data.surveyId;
    }
    else {
      this.selectedSurveryIDTrainers = data.surveyId;
    }
  }

  setSelectedSurveyImpact(data: any) {
    this.selectedSurveyImpactID = data.surveyId;
  }

  async submitRating() {
    try {
      this.userRating
      if (!this.userRating) return
      let data: any = {
        _id: this.courseId,
        trainerRating: { _id: localStorage.getItem('uid'), userRating: this.userRating }
      }
      let res = await this.dataService.postData('course/trainer-rating/', data)
      if (res.error) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('error') });
        return
      }
      this.userRating = undefined
      this.ratingModal = false
      this.messageService.add({ severity: 'success', summary: this.translate('success'), detail: this.translate('Rating Submitted Successfully!') });
    } catch (error) {
      console.log(error)
    }

  }

  canRateUser(): boolean {
    return !!this.courseData?.training_request?.ratingSettings?.surveryIdUsers;
  }

  canRateTrainer(): boolean {
    return !!this.courseData?.training_request?.ratingSettings?.surveryIdTrainers;
  }



  // End User Rating


}


export interface TrainingDataAdditionTabs {
  online_session: boolean,
  onside_session: boolean,
  video_session: boolean,
  add_assessment: boolean,
  add_survey: boolean
  certificate: boolean
}

export enum AdditionTabs {
  Session = 'SESSION',
  Survey = 'SURVEY',
  Assessment = 'ASSESSMENT',
  Source = 'SOURCE',
  Add_User = 'ADD USER',
}

export enum TrainingDataTabs {
  Session,
  Survey,
  Assessment,
  Source,
  Contents,
  Attendance,
  CourseMaterial,
  Certificate
}

export enum SessionContentType {
  Online = 'Online',
  Onsite = 'Onsite',
  Video = 'Video',
  Survey = 'Survey',
  Assessment = 'Assessment',
  Certificate = 'Certificate'
}